// @flow
import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as Responsive from '../responsive'

type Props = {|
  +className?: string,
  image:
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>
    | React.Element<'img'>,
  mobileImage:
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>
    | React.Element<'img'>,
|}

export const Reviews = ({ className, image, mobileImage }: Props) => {
  return (
    <Wrapper className={className}>
      <InnerWrapper>
        <Responsive.DesktopOnly>
          <DesktopWrapper>{image}</DesktopWrapper>
        </Responsive.DesktopOnly>
        <Responsive.MobileOnly>{mobileImage}</Responsive.MobileOnly>
      </InnerWrapper>
    </Wrapper>
  )
}

const InnerWrapper = styled.div`
  background: ${colors.darkPurple80};
  padding: 35px 30px;
  ${media.mq[1]} {
    margin-top: 50px;
    padding: 60px 30px 20px;
  }
  ${media.mq[2]} {
    margin-top: 100px;
  }
`

const DesktopWrapper = styled.div`
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
  ${media.mq[1]} {
    margin-top: -80px;
  }
  ${media.mq[2]} {
    margin-top: -95px;
  }
`
const Wrapper: React.ComponentType<any> = styled.div`
  background: ${colors.darkPurple90};
  text-align: center;
`
